import { FC } from "react";
import { CommonIconProps } from "../Icon/types";

const TrackingPixels: FC<CommonIconProps> = ({
  fill = "var(--icon-fill-color, var(--color-primary))",
  stroke = "var(--icon-stroke-color, none)"
}) => {
  return (
    <svg
      className="icon-tracking-pixels"
      width="100%"
      height="100%"
      viewBox="0 0 16 16"
      fill={fill}
      stroke={stroke}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.65854 2.00093C11.298 1.9584 13.7359 3.37563 14.9547 5.66192L14.9606 5.67332C15.0742 5.9004 15.1617 6.13902 15.2217 6.38486C15.2872 6.65348 15.1172 6.92307 14.8421 6.98702C14.5669 7.05098 14.2907 6.88506 14.2252 6.61645C14.1832 6.4442 14.122 6.27695 14.0428 6.11766C13.001 4.16866 10.9199 2.9617 8.66766 3.00085C8.66158 3.00095 8.6555 3.00095 8.64942 3.00085C6.39687 2.9617 4.31544 4.16905 3.27375 6.1186C2.94119 6.7802 2.94127 7.55488 3.27399 8.21642C4.20618 9.97053 5.99841 11.1323 8.01659 11.2905C8.29856 11.3126 8.5088 11.5536 8.48616 11.8288C8.46353 12.1041 8.2166 12.3093 7.93463 12.2872C5.56239 12.1013 3.45595 10.7347 2.36191 8.67168C2.36014 8.66832 2.3584 8.66496 2.35671 8.66159C1.88085 7.71898 1.8811 6.61393 2.35745 5.6715C2.35924 5.66795 2.36107 5.66444 2.36293 5.66096C3.58191 3.37523 6.01942 1.95841 8.65854 2.00093Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0976 9.66708C12.0603 9.66708 11.2195 10.4878 11.2195 11.5003C11.2195 11.8786 11.4397 12.3333 11.8117 12.8076C12.171 13.2657 12.6173 13.6735 12.9518 13.9507C13.0375 14.0165 13.1582 14.0165 13.2439 13.9508C13.5782 13.6735 14.0243 13.2657 14.3835 12.8076C14.7554 12.3333 14.9756 11.8786 14.9756 11.5003C14.9756 10.4878 14.1348 9.66708 13.0976 9.66708ZM13.0976 8.66716C11.4946 8.66716 10.1951 9.93559 10.1951 11.5003C10.1951 12.2142 10.5855 12.8891 10.9983 13.4154C11.4221 13.9557 11.9322 14.4179 12.2944 14.7177L12.3025 14.7242C12.7659 15.0919 13.4299 15.0919 13.8933 14.7242L13.9015 14.7175C14.2633 14.4178 14.7733 13.9557 15.1969 13.4154C15.6096 12.889 16 12.2142 16 11.5003C16 9.93559 14.7005 8.66716 13.0976 8.66716Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.65854 6.334C8.18707 6.334 7.80488 6.70707 7.80488 7.16727C7.80488 7.62747 8.18707 8.00054 8.65854 8.00054C9.13 8.00054 9.5122 7.62747 9.5122 7.16727C9.5122 6.70707 9.13 6.334 8.65854 6.334ZM6.78049 7.16727C6.78049 6.15483 7.62132 5.33408 8.65854 5.33408C9.69575 5.33408 10.5366 6.15483 10.5366 7.16727C10.5366 8.17972 9.69575 9.00046 8.65854 9.00046C7.62132 9.00046 6.78049 8.17972 6.78049 7.16727Z"
      />
      <path d="M13.7805 11.5003C13.7805 11.8684 13.4747 12.1669 13.0976 12.1669C12.7204 12.1669 12.4146 11.8684 12.4146 11.5003C12.4146 11.1321 12.7204 10.8337 13.0976 10.8337C13.4747 10.8337 13.7805 11.1321 13.7805 11.5003Z" />
    </svg>
  );
};

export default TrackingPixels;
